module.exports = __webpack_public_path__ + "img/57.5b6aaeb8.jpg";